module.exports = __webpack_public_path__ + "static/media/centered.516e52c2.svg";